/**
 * Single source of truth for the copy shown on org-object name collisions.
 *
 * ER-11899 / MDP-608: every create/rename dialog for a Role, Responsibility,
 * Department, Job Family, Job Family Level or Job Category must show the exact
 * same inline message — replacing the two old variants
 * ("Name already exists. Only Unique names are allowed." /
 * "Name already exists. Only unique names are allowed.").
 */
export const NAME_IN_USE = "This name is already in use. Enter a different name.";

/**
 * Maps a write error to the inline name-in-use copy: HTTP 409 with a
 * `*_DUPLICATE_NAME` code. Returns "" for any other error.
 */
export const nameConflictMessage = (err) => {
  const response = err && err.response;
  const code = response && response.data && response.data.code;
  return response && response.status === 409 && typeof code === "string" && /_DUPLICATE_NAME$/i.test(code)
    ? NAME_IN_USE
    : "";
};
